import { ITab } from '@components/std-components/TabsStrip'
import {
  CORE_PRODUCT_FILTER_VALUES,
  RECOMMENDED_PRODUCTS_FILTER_VALUES
} from '@modules/order/constants/uiConstants'
import { PRODUCT_MISC_FIELD_IDS } from './product-misc-field-ids'
import { WISHLIST_FILTER_TABS } from './wishlist-filter-tabs'
import { ProductCardSizes } from '@constants'
import { VIPClientType } from '@modules/common/models/enums/VIPClientType'

export const HIERARCHY_ROOT_ID = 'activities'
export const PRODUCT_CARD_DIMENSIONS = {
  [ProductCardSizes.Large]: {
    width: 260,
    height: 425
  },
  [ProductCardSizes.Medium]: {
    width: 190,
    height: 425
  },
  [ProductCardSizes.Small]: {
    width: 160,
    height: 425
  }
}

export const ENHANCED_PRODUCT_CARD_DIMENSIONS = {
  [ProductCardSizes.Large]: {
    width: 260,
    height: 425
  },
  [ProductCardSizes.Medium]: {
    width: 210,
    height: 425
  },
  [ProductCardSizes.Small]: {
    width: 160,
    height: 425
  }
}

export const DEFAULT_CONTENT_MIN_HEIGHT = 50
export const PRODUCT_IMAGE_HEIGHT = 212
export const HIERARCHY_ELEMENT_HEIGHT = 28
export const HEIRARCHY_PAGE_SIZE = 5
export const DOOR_NAME_SEPERATOR = '/ '
export const CATEGORY_UI_SEPERATOR = ' / '
export const ENHANCED_HIERARCHY_ELEMENT_HEIGHT = 40

export interface TabConfig extends ITab {}

export enum ProductField {
  Color = 'Color',
  Material = 'Material',
  Family = 'Family',
  Line = 'Line',
  Activity = 'Activity',
  Title = 'Title',
  SKU = 'SKU'
}

export enum PRODUCT_PRESENTATION_FILTER_TAB_IDS {
  WISHLIST_PRODUCT = 'isFavorite'
}

export enum WISH_LIST_PRODUCT_FILTER_VALUES {
  SELECTED = 'SELECTED',
  NOT_SELECTED = 'NOT SELECTED'
}

export const WISHLIST_FILTER_ALL_TABS = WISHLIST_FILTER_TABS.concat([
  {
    id: PRODUCT_PRESENTATION_FILTER_TAB_IDS.WISHLIST_PRODUCT,
    name: 'WISHLIST',
    clientTypes: [VIPClientType.External, VIPClientType.Internal],
    key: 'filter.wishlist'
  }
])

export const STATIC_FILTERS = {
  [PRODUCT_PRESENTATION_FILTER_TAB_IDS.WISHLIST_PRODUCT]: [
    WISH_LIST_PRODUCT_FILTER_VALUES.SELECTED,
    WISH_LIST_PRODUCT_FILTER_VALUES.NOT_SELECTED
  ],
  [PRODUCT_MISC_FIELD_IDS.RECOMMENDED_PRODUCTS]: [
    RECOMMENDED_PRODUCTS_FILTER_VALUES.RECOMMENDED_PRODUCTS,
    RECOMMENDED_PRODUCTS_FILTER_VALUES.NON_RECOMMENDED_PRODUCTS
  ],
  [PRODUCT_MISC_FIELD_IDS.CORE_PRODUCTS]: [
    CORE_PRODUCT_FILTER_VALUES.CORE_PRODUCTS,
    CORE_PRODUCT_FILTER_VALUES.NON_CORE_PRODUCTS
  ]
}
export const QUANTITY_DETAIL_PRODUCT_CARD_HEIGHT = 230
export const QUANTITY_DETAIL_PRODUCT_CARD_WIDTH = 84
